import { cn } from '@/lib/utils';
import type { HistoryChartPoint, VersionChartPoint } from '../types';

export function HistoryRunDot(props: any) {
  const { cx, cy, payload, onSelectRun } = props;
  if (typeof cx !== 'number' || typeof cy !== 'number' || !payload?.id) return null;

  const hasScore = typeof payload.score === 'number';
  return (
    <circle
      cx={cx}
      cy={cy}
      r={hasScore ? 4 : 3}
      className={cn(
        'cursor-pointer transition-opacity hover:opacity-80',
        hasScore ? 'fill-primary' : 'fill-muted-foreground/40',
      )}
      onClick={() => onSelectRun(payload.id)}
    />
  );
}

export function HistoryChartTooltip({ active, payload }: { active?: boolean; payload?: Array<{ payload?: HistoryChartPoint }> }) {
  if (!active || !payload?.length) return null;

  const point = payload.find((item) => item.payload?.id)?.payload;
  if (!point) return null;

  const versionLabel = [point.agentVersion, point.agentVersionTag]
    .filter((value) => value && value !== '-')
    .join(' · ') || '-';

  return (
    <div className="min-w-[180px] rounded-[6px] border border-border bg-background px-3 py-2 text-xs shadow-[0px_15px_15px_0px_rgba(0,0,0,0.09)]">
      <p className="font-medium text-foreground">{point.dateLabel}</p>
      <div className="mt-2 grid gap-1.5">
        <div className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">Average score</span>
          <span className="font-medium tabular-nums text-foreground">{point.score ?? 'Not scored'}</span>
        </div>
        <div className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">Agent version</span>
          <span className="font-medium text-foreground">{versionLabel}</span>
        </div>
      </div>
    </div>
  );
}

export function VersionChartTooltip({ active, payload }: { active?: boolean; payload?: Array<{ payload?: VersionChartPoint }> }) {
  if (!active || !payload?.length) return null;

  const point = payload.find((item) => item.payload?.id)?.payload;
  if (!point) return null;

  return (
    <div className="min-w-[180px] rounded-[6px] border border-border bg-background px-3 py-2 text-xs shadow-[0px_15px_15px_0px_rgba(0,0,0,0.09)]">
      <p className="font-medium text-foreground">{point.version}</p>
      <div className="mt-2 grid gap-1.5">
        <div className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">Average score</span>
          <span className="font-medium tabular-nums text-foreground">{point.score ?? 'Not scored'}</span>
        </div>
        <div className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">Runs</span>
          <span className="font-medium tabular-nums text-foreground">{point.runCount}</span>
        </div>
      </div>
    </div>
  );
}
